<template>
    <el-dialog class="el-dialogs" :append-to-body="true" :title="title" :fullscreen="true" :close-on-click-modal="false"
               :visible.sync="visible">
        <div class="pageTop" style="margin-bottom: 25px">
            <el-steps :active="stepChange + 1" finish-status="success" align-center>
                <el-step title="入库申请基本信息"></el-step>
                <el-step title="入库藏品"></el-step>
                <el-step title="预览完成"></el-step>
            </el-steps>
        </div>
        <div class="mingTitlr" v-show="stepChange == 2">出库基本信息</div>
        <div class="pageTop">
            <el-form v-show="stepChange == 0 || stepChange == 2" size="small" ref="searchForm" :model="searchForm"
                     :rules="rules"
                     label-width="110px">
                <div class="flex_b_c flex_w">
                    <el-form-item label="入库原因" prop="inWarehouseCause" style="width: 33%">
                        <el-select v-if="stepChange != 2" v-model="searchForm.inWarehouseCause"
                                   placeholder="请选择入库原因" style="width: 100%"
                                   clearable>
                            <el-option
                                    v-for="item in $dictUtils.getDictList('in_warehouse_cause')"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                        <div v-else>{{
                            $dictUtils.getDictLabel("in_warehouse_cause", searchForm.inWarehouseCause, '')
                            }}
                        </div>
                    </el-form-item>
                    <el-form-item label="预入库时间：" prop="inWarehouseTime" style="width: 33%">
                        <el-date-picker
                                v-if="stepChange != 2"
                                style="width: 100%"
                                v-model="searchForm.inWarehouseTime"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择预入库时间">
                        </el-date-picker>
                        <div v-else>{{ searchForm.inWarehouseTime }}</div>
                    </el-form-item>
                    <el-form-item label="申请人：" prop="applicantName" style="width: 33%">
                        <el-input v-if="stepChange != 2" v-model="searchForm.applicantName" disabled
                                  placeholder="请输入申请人"></el-input>
                        <div v-else>{{ searchForm.applicantName }}</div>
                    </el-form-item>
                </div>
                <el-form-item label="入库描述" prop="inWarehouseDescribe">
                    <el-input
                            v-if="stepChange != 2"
                            type="textarea"
                            placeholder="请输入入库描述(限200字)"
                            v-model="searchForm.inWarehouseDescribe"
                            rows="5" resize="none"
                            maxlength="200"
                    >
                    </el-input>
                    <div v-else>{{ searchForm.inWarehouseDescribe }}</div>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input
                            v-if="stepChange != 2"
                            type="textarea"
                            placeholder="请输入备注(限200字)"
                            v-model="searchForm.remark"
                            rows="5" resize="none"
                            maxlength="200"
                    >
                    </el-input>
                    <div v-else>{{ searchForm.remark }}</div>
                </el-form-item>
                <el-form-item label="附件" prop="metadataAttachments">
                    <resume-upload ref="resumeUpload" :disabledBut="stepChange == 2" :uploadNum="12" :upFileSize="10000"
                                   :filtButton="true"
                                   @upFileDate="getUpDataFile"></resume-upload>
                    <div class="metadataAttachmentsList">
                        <el-card class="elCard" v-for="(item,index) in searchForm.metadataAttachments" :key="item.id">
                            <div class="flex_b_c">
                                <div class="flex_l_c flex_1">
                                    <i class="el-icon-tickets icong"></i>
                                    <el-tooltip class="item" effect="dark" :content="item.fileName"
                                                placement="top-start">
                                        <div class="content omit">{{ item.fileName }}</div>
                                    </el-tooltip>
                                </div>
                                <div>
                                    <i class="el-icon-circle-close deeldClose" v-if="stepChange != 2"
                                       @click="deleteUpData(item,index)"></i>
                                </div>
                            </div>
                        </el-card>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div v-show="stepChange == 1 || stepChange == 2" class="b_d" style="height: calc(100% - 60px)">
            <div v-if="!basicDataList.length && stepChange != 2" class="text_center magTop">
                <el-button size="small" type="primary" @click="selectColl()">选择藏品</el-button>
            </div>
            <el-row v-else :gutter="4" class="h100 configurationList">
                <el-col :span="showList ? 4 : 1" :class="['p_r h100i', showList ? '' : 'el-col-unfold']">
                    <div :class="['unfoldClassifyBtn', showList ? 'el-icon-arrow-left':'el-icon-arrow-right']"
                         @click="showList = !showList"></div>
                    <el-menu class="h100 metadataTree" :default-active="searchForm.basicDataId" @select="selectMenu">
                        <el-menu-item :index="item.basicDataId" v-for="item in basicDataList" :key="item.basicDataId">
                            <span slot="title">{{ item.basicDataName }}</span>
                        </el-menu-item>
                    </el-menu>
                </el-col>
                <el-col :span="showList ? 20 : 24" :class="['h100', showList ? '' : 'el-col-unfold']">
                    <div class="el-table-container">
                        <el-form size="small" class="query-form" ref="form" :model="searchForm" inline
                                 label-width="100px" @keyup.enter.native="refreshList(1)">
                            <el-form-item prop="keyword" label="关键字：">
                                <el-input v-model.trim="keyword" maxlength="20"
                                          placeholder="请输入关键字(限20字)"
                                          clearable></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" icon="el-icon-search" @click="refreshList(1)" size="small">查询
                                </el-button>
                                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
                            </el-form-item>
                            <el-form-item class="f_r" v-if="stepChange != 2">
                                <el-button type="primary" @click="selectColl()" size="small">选择藏品
                                </el-button>
                                <el-button @click="deleteData()" size="small">删除</el-button>
                            </el-form-item>
                        </el-form>
                        <el-table
                                :data="dataList2"
                                size="small" height="100%"
                                class="table" ref="multipleTable" border
                                @selection-change="selectionChangeHandle" row-key='id'
                        >
                            <el-table-column type="selection" :reserve-selection='true' fixed/>
                            <el-table-column prop="zongzhangbianhaodgxoqzkpzz" label="资源编号" show-overflow-tooltip>
                                <template slot-scope="{row}">
                                    <div>{{ row.jsonData.zongzhangbianhaodgxoqzkpzz}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="mingcheng" label="资源名称" show-overflow-tooltip>
                                <template slot-scope="{row}">
                                    <div>{{ row.jsonData.mingcheng}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="kucunzhuangtaicfqvrvqdye" label="状态" show-overflow-tooltip>
                                <template slot-scope="{row}">
                                    <div>{{ row.jsonData.kucunzhuangtaicfqvrvqdye}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column fixed="right" min-width="100px" label="操作">
                                <template slot-scope="{row}">
                                    <el-button type="text" size="small" @click="detail(row)">详情</el-button>
                                    <el-button type="text" v-if="stepChange != 2" size="small" @click="deleteData(row)">
                                        删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <pagination :total="total" :page.sync="current" :limit.sync="size"
                                    @pagination="refreshList"/>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div slot="footer" class="text_right">
            <el-button size="small" v-if="stepChange > 0" @click="nextStep('up')">上一步</el-button>
            <el-button size="small" v-if="stepChange != 2" @click="nextStep()">下一步</el-button>
            <el-button size="small" v-if="stepChange == 2" key="doSubmit" type="primary" @click="doSubmit(0)" v-noMoreClick>保存</el-button>
            <el-button size="small" v-if="stepChange == 2" key="doSubmit" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
        </div>
        <select-coll ref="selectColl" @refreshAssociatedData="refreshAssociatedData"></select-coll>
        <resource-add-edit-form ref="resourceAddEditForm"></resource-add-edit-form>
    </el-dialog>
</template>

<script>
import ResumeUpload from "@/components/Upload/resumeUpload.vue";
import SelectColl from "@/views/modules/collection/common/selectColl.vue";
import ResourceAddEditForm from "@/views/modules/dyygCollect/library/resourceAddEditForm.vue";

export default {
    name: "addApplyFor",
    components: {ResourceAddEditForm, SelectColl, ResumeUpload},
    data() {
        return {
            title: '入库申请',
            visible: false,
            stepChange: 0,
            searchForm: {
                id: '',
                inWarehouseCause: '',
                inWarehouseTime: '',
                applicant: '',
                inWarehouseDescribe: '',
                remark: '',
                metadataAttachments: [],
            },
            rules: {
                inWarehouseCause: [
                    {required: true, message: '请选择入库原因', trigger: 'change'}
                ],
                inWarehouseTime: [
                    {required: true, message: '请选择预入库时间', trigger: 'change'}
                ],
            },
            showList: true,
            selectAllData: [],
            basicDataId: '',
            keyword: '',
            basicDataList: [],
            dataList: [],
            dataList2: [],
            dataListSelections: [],
            current: 1,
            size: 20,
            total: 0,
            seleData: {},
        }
    },

    mounted() {
        let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        this.searchForm.applicantName = userInfo.name
        this.searchForm.applicant = userInfo.id
    },

    methods: {
        // name add新增 view详情 edit编辑
        init(name, row) {
            this.visible = true
            this.stepChange = 0
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields()
            })
            this.selectAllData = []
            this.basicDataList = []
            if (name == 'add') {
                this.seleData = row
                this.title = '编辑入库申请'
                this.getDetail()
            }
        },

        getDetail() {
            this.$axios(this.api.collection.getInWarehouseById + this.seleData.id).then(data => {
                if (data && data.status) {
                    Object.keys(this.searchForm).forEach(key => {
                        this.searchForm[key] = data.data[key]
                    })
                    this.basicDataList = data.data.metadataBasicVOS
                    this.basicDataList.forEach(item => {
                        this.$set(item, 'metadataDataElasticSearchList', data.data.metadataBasicMap[item.basicDataId])
                    })
                    this.$refs.resumeUpload.setOldFile(this.searchForm.metadataAttachments)
                    this.selectAllData = data.data.collectionOutWarehouseItems.map(item => {
                        return item.dataId
                    })
                    this.selectMenu(this.basicDataList[0].basicDataId)
                }
            })
        },

        getUpDataFile(data) {
            this.searchForm.metadataAttachments = data.map(item => {
                if (item.upDate) {
                    this.$set(item.upDate, 'newId', item.id)
                    return item.upDate
                } else {
                    return item
                }
            })
        },

        deleteUpData(row, index) {
            this.$refs.resumeUpload.deleteFile(row.newId ? row.newId : row.id)
            this.searchForm.metadataAttachments.splice(index, 1)
        },

        //下一步
        nextStep(type) {
            if (type) {
                this.stepChange--;
                return
            }
            if (this.stepChange == 0) {
                this.$refs.searchForm.validate((valid) => {
                    if (valid) {
                        this.stepChange++;
                    }
                });
                return;
            }
            if (this.stepChange == 1) {
                if (this.selectAllData.length != 0) {
                    this.stepChange++;
                } else {
                    this.$message.error('请选择藏品')
                    return;
                }
            }
        },


        //选择藏品
        selectColl() {
            this.$refs.selectColl.init('1879352716032077826', this.selectAllData)
        },

        refreshAssociatedData(data) {
            if (this.basicDataList.length){
                data.basicDataIdList.forEach(item1=>{
                    this.basicDataList.forEach(item2=>{
                        if (item1.basicDataId == item2.basicDataId){
                            item2.metadataDataElasticSearchList.push(...item1.metadataDataElasticSearchList)
                        }
                    })
                    let reapetList = this.basicDataList.filter(item2=>item1.basicDataId == item2.basicDataId)
                    if (reapetList.length == 0){
                        this.basicDataList.push(item1)
                    }
                })
            }else {
                this.basicDataList = data.basicDataIdList
            }
            this.selectAllData.push(...data.selId)
            this.selectMenu(this.basicDataList[0].basicDataId)
        },

        mergeArrays(array1, array2) {
            const map = new Map();

            // 将第一个数组的元素添加到 Map 中
            array1.forEach(item => {
                map.set(item.basicDataId, { ...item });
            });

            // 遍历第二个数组，如果 Map 中已有相同的 basicDataId，则更新它，否则添加新的元素
            array2.forEach(item => {
                if (map.has(item.basicDataId)) {
                    map.set(item.basicDataId, { ...map.get(item.basicDataId), ...item });
                } else {
                    map.set(item.basicDataId, { ...item });
                }
            });

            // 将 Map 的值转换为数组
            return Array.from(map.values());
        },

        // 选择树节点
        selectMenu(val) {
            this.basicDataId = val
            this.reset()
        },

        // 重置
        reset(type) {
            this.keyword = ''
            this.refreshList(1)
        },

        // 获取数据列表 current: 1第一页
        refreshList(current, clearList) {
            if (current == 1) {
                this.current = 1
            }
            if (clearList) {
                this.$refs.multipleTable.clearSelection()
            }

            this.basicDataList.forEach(item => {
                if (item.basicDataId == this.basicDataId) {
                    this.dataList = [...item.metadataDataElasticSearchList]
                }
            })
            this.total = this.dataList.length
            if (this.keyword !== '') {
                this.dataList = this.dataList.filter(item => {
                    if (item.jsonData.mingcheng) {
                        return item.jsonData.mingcheng.indexOf(this.keyword) != -1
                    }
                })
            }
            this.dataList2 = this.dataList.splice((this.current - 1) * this.size, this.current * this.size)
            if (this.dataList2.length == 0 && this.current > 1) {
                this.current--
                this.refreshList()
            }
        },

        // 多选
        selectionChangeHandle(val) {
            let ids = val.map(item => {
                return item.id
            })
            this.dataListSelections = this.selectedId.concat(ids)
        },

        //资源详情
        detail(row) {
            this.$refs.resourceAddEditForm.init('view', row.id, '', row.basicDataId, '', row)
        },

        //删除关联数据
        deleteData(row) {
            let list = row ? [row.id] : this.dataListSelections
            if (!list.length) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            this.$confirm(`确定删除所选项吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.basicDataList.forEach(item => {
                    if (item.basicDataId == this.basicDataId) {
                        item.metadataDataElasticSearchList = item.metadataDataElasticSearchList.filter(item1 =>
                            list.findIndex(item2 => item2 === item1.id) === -1
                        );
                        this.selectAllData = this.selectAllData.filter(item1 =>
                            list.findIndex(item2 => item2 === item1) === -1
                        );
                    }
                })
                this.$message.success('删除成功')
                this.refreshList('', 1)
            })
        },

        //提交
        doSubmit(num) {
            this.$axios(this.api.collection.collectioninwarehouseSaveOrUpdate, {
                ...this.searchForm,
                data: this.selectAllData,
                status:num,
            }, 'post').then(data => {
                if (data && data.status) {
                    this.$message.success('提交成功')
                    this.visible = false
                    this.$emit('refresh')
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.pageTop {
  width: 70%;
  margin: 0 auto;
}

.mingTitlr {
  font-weight: bold;
  margin-left: 20px;
  margin-bottom: 15px;
}

.magTop {
  margin-top: 20vh;
}

.metadataAttachmentsList {
  height: 250px;
  overflow-y: auto;
}

.elCard {
  &::v-deep .el-card__body {
    padding: 10px !important;
  }

  margin-bottom: 15px;

  .icong {
    font-size: 18px;
    margin-right: 10px;
  }

  .content {
    width: 80%;
  }

  .deeldClose {
    font-size: 18px;
    cursor: pointer;
  }
}
</style>